module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/108-armenia-1283b1c220b5728a1e2f2d0f8834307f.svg";